module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-filter text-dark",
    class: {
      'flex_columns': _vm.columns
    }
  }, [_c('div', {
    staticClass: "tags_filter__selected"
  }, [_c('div', {
    staticClass: "icon-filter"
  }), _vm._v(" "), _c('div', {
    staticClass: "tags_filter__selected"
  }, [_c('ul', _vm._l((_vm.selectedTags), function(tag) {
    return _c('li', [_c('tag', {
      attrs: {
        "tag": tag
      },
      on: {
        "remove": _vm.removeTag
      }
    })], 1)
  }), 0)])]), _vm._v(" "), (!_vm.active) ? _c('button', {
    staticClass: "btn-trans tags-filter__header__s-btn",
    on: {
      "click": function($event) {
        _vm.active = true
      }
    }
  }, [_vm._v("+\n    " + _vm._s(_vm.searchText.length > 1 ? _vm.searchText : _vm.$t('vue2.tagging.search_tag')) + "\n  ")]) : _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.hideActive),
      expression: "hideActive"
    }],
    staticClass: "tags-filter-wrapper"
  }, [_c('div', {
    staticClass: "tags-filter__header"
  }, [_c('span', {
    staticClass: "icon-search5"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.tagText),
      expression: "tagText"
    }],
    staticClass: "tags-filter__header__search",
    class: {
      'show': _vm.showDropdown
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tagText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tagText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tags_filter__tags",
    class: {
      'show': _vm.showDropdown
    }
  }, [(!_vm.isShowNoTagsText && (_vm.tags.length === 0)) ? _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))]) : _vm._e(), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tags.length < 1 && _vm.isShowNoTagsText),
      expression: "tags.length < 1 && isShowNoTagsText"
    }]
  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.you_have_created_zero_tags')) + "\n        "), _c('a', {
    attrs: {
      "href": '/schools/' + _vm.schoolid + '/groups/#/'
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.create_tags')))])]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredTags.length < 1 && _vm.tags.length > 0),
      expression: "filteredTags.length < 1 && tags.length > 0"
    }]
  }, [_vm._v("0 " + _vm._s(_vm.$t('vue2.tagging.with')) + " \"" + _vm._s(_vm.tagText) + "\"")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredTags.length > 0),
      expression: "filteredTags.length > 0"
    }]
  }, _vm._l((_vm.notSelectedTags), function(tag) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.setTag(tag)
        }
      }
    }, [_c('span', {
      staticClass: "icon-price-tag2"
    }), _vm._v(" " + _vm._s(tag) + " "), (_vm.showHowMany) ? _c('span', [_vm._v("(" + _vm._s(_vm.howManyWithTag(tag)) + ")")]) : _vm._e()])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-609167cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tagging/TaggingFilter.vue
// module id = 1953
// module chunks = 1